import React, { Component } from 'react';
import { PANEL_OPEN_EVENT } from '../../../support/supportEntry';
import { connect } from 'react-redux';
import Aux from 'hoc/ReactAux/ReactAux';
import Categories from '../MenuComponents/Categories/Categories';
import PopularDish from '../MenuComponents/PopularDish';
import ProductsDetails from '../MenuComponents/Products/ProductDetails/ProductDetails';
import ModalCartMessage from 'components/UI/Modal/ModalCartMessage';
import ModalErrorPlacedOrder from 'components/UI/Modal/ModalError';
import ModalSuccessPayment from 'components/UI/Modal/ModalSuccessPayment';
import ModalReceipt from 'components/UI/Modal/ModalReceipt';
import RecentlyOrdered from '../MenuComponents/RecentlyOrdered/RecentlyOrdered';
import ErrorHandling from 'hoc/ErroHandling';
import * as menuActions from 'actions/index';
import Cart from '../Cart/Cart';
import objectUtils from 'utils/object';
import currencyUtils from 'utils/currency';
import { setSupportContext } from '../../../support/context';
import { ERROR_CODES, knownError } from 'utils/userError';

class DefaultMenu extends Component {
  state = {
    categoriesType: [
      { id: 0, name: 'Popular Dishes', active: true },
      { id: 1, name: 'Recently Ordered', active: false },
    ],
    differentRestaurant: false,
    productStandBy: null,
    businessStandBy: null,
    showCategoriesMobile: false,
    showRestaurantsMobile: false,
  };

  componentWillUnmount() {
    window.removeEventListener(PANEL_OPEN_EVENT, this.closeCategoriesSheet);
  }

  componentDidMount(prevProps) {
    window.addEventListener(PANEL_OPEN_EVENT, this.closeCategoriesSheet);
    const reorderId =
      this.props.match && this.props.match.params && this.props.match.params.idOrder;
    if (reorderId) setSupportContext('order.detail', { orderIds: [reorderId] });
    this.props.onFetchingMenu(
      this.props.userDetails.idBusiness,
      localStorage.getItem('idBusinessAddress')
    );
    if (this.props.listAddress.length === 0) {
      this.props.onFetchingListAddressForOrder({
        email: this.props.userDetails.username,
      });
    }
    this.props.onChangeTitleHeader('Popular Dishes');
    localStorage.removeItem('PayInfo');
  }

  getAmount() {
    return objectUtils.get(this.props, 'cart.payInfo.amount', 0);
  }

  getCurrency() {
    return currencyUtils.convertNameToSymbol(
      objectUtils.get(this.props, 'cart.restaurantSelected.currency', 'EUR')
    );
  }

  // The support conversation opened on a small screen: the Categories sheet mustn't cover it.
  closeCategoriesSheet = () => {
    if (this.state.showCategoriesMobile) this.setState({ showCategoriesMobile: false });
  };

  toggleCategoriesNavClass = () => {
    this.props.onToggleCart(false);
    this.props.onToggleRestaurants(false);
    this.setState({
      showCategoriesMobile: !this.state.showCategoriesMobile,
    });
  };

  toggleCart = () => {
    this.props.onToggleCart();
    this.props.onToggleRestaurants(false);
    this.setState({
      showCategoriesMobile: false,
    });
  };

  toggleRestaurants = () => {
    this.props.onToggleCart(false);
    this.props.onToggleRestaurants();
    this.setState({
      showCategoriesMobile: false,
    });
  };

  getSurcharge = () => {
    const isPayTypeCreditCard = payType => payType === 'C';
    const payType = objectUtils.get(
      this.props,
      'cart.payInfo.payType',
      undefined
    );
    if (isPayTypeCreditCard(payType)) {
      return objectUtils.get(this.props, 'cart.campaignRateCC.amount', 0);
    }
    return 0;
  };

  getSubTotal() {
    return objectUtils.get(this.props, 'cart.subtotal', 0);
  }

  getTaxDelivery = () => {
    return !!this.props.restaurantOnCart &&
      this.props.restaurantOnCart.taxDelivery &&
      this.isDeliverAtHome()
      ? this.props.restaurantOnCart.taxDelivery.toFixed(2)
      : Number(0).toFixed(2);
  };

  getCollectionDiscount = () => {
    let campaignRateCollection = objectUtils.get(
      this.props,
      'cart.campaignRateCollection',
      null
    );
    if (campaignRateCollection) {
      let collectionDiscount =
        campaignRateCollection.discountType === 'P'
          ? `% ${campaignRateCollection.amount}`
          : `- ${campaignRateCollection.amount}`;
      return collectionDiscount;
    } else {
      return '';
    }
  };

  isForCollection = () => {
    return objectUtils.get(
      this.props,
      'cart.restaurantSelected.forCollection',
      'N'
    );
  };

  getReceiptData = () => {
    return {
      cart: this.props.cart,
      total: this.getAmount(),
      currency: this.getCurrency(),
      surcharge: this.getSurcharge(),
      subtotal: this.getSubTotal(),
      taxDelivery: this.getTaxDelivery(),
      userDetails: this.props.userDetails,
      orderDeliveryDate: objectUtils.get(
        this.props,
        'cart.orderDeliveryDate',
        undefined
      ),
      collectionDiscount: this.getCollectionDiscount(),
      forCollection: this.isForCollection(),
      address: this.getAddress(),
      tipValue: objectUtils.get(this.props, 'cart.tipValue', 0),
    };
  };

  handleSelectCategory = id => {
    let categoriesTypeUpdate = this.state.categoriesType.map(category => {
      if (category.active) {
        category.active = false;
      } else if (category.id === id) {
        category.active = true;
      }
      return category;
    });
    this.props.onChangeTitleHeader(categoriesTypeUpdate[id].name);
    this.setState({ categoriesType: categoriesTypeUpdate });
  };

  handleSelectProductFromPopularDish = idProduct => {
    let popularDishItem = this.props.popularDishDelivery.find(item => {
      return item.product.id === idProduct;
    });

    if (popularDishItem.business.isOpen) {
      if (this.verifyIfRestaurantInCart(popularDishItem.business.id)) {
        this.setState({ productStandBy: popularDishItem.product });
        this.setState({ businessStandBy: popularDishItem.business });
      } else {
        this.props.onRestaurantSelected(popularDishItem.business);
        this.props.onFetchingMealOptionsFromPopularDish(popularDishItem);
      }
    } else {
      this.props.onErrorHandling({
        showError: true,
        errorMessage: knownError(ERROR_CODES.MENU_RESTAURANT_CLOSED, {
          title: "This restaurant is closed now",
          message: 'It has stopped taking orders for today.',
          guidance: 'Choose another restaurant, or order for tomorrow.',
        }),
      });
    }
  };

  handleAddRecentlyOrderProduct = item => {
    let productsLastOrder = item.orderItems.map(function(orderItem) {
      let productMap = {
        ...orderItem.product,
        mealOptions: orderItem.mealOptions ? orderItem.mealOptions : [],
      };
      let price = 0;
      if (orderItem.mealOptions) {
        price = orderItem.mealOptions.reduce((inicial, item) => {
          return inicial + item.product.price;
        }, 0);
      }
      price = price + orderItem.product.price;
      productMap.price = price;
      return productMap;
    });

    if (this.verifyIfRestaurantInCart(item.restaurant.id)) {
      this.setState({ productStandBy: productsLastOrder });
      this.setState({ businessStandBy: item.restaurant });
    } else {
      this.props.onAddProductToCart({
        product: productsLastOrder,
        business: item.restaurant,
      });
      this.props.onRestaurantSelected(item.restaurant);
    }
  };

  verifyIfRestaurantInCart = idRestaurant => {
    let isDifferent = !this.props.restaurantOnCart
      ? false
      : this.props.restaurantOnCart.id !== idRestaurant;
    this.setState({ differentRestaurant: isDifferent });
    return isDifferent;
  };

  handleConfirmOkCartModal = () => {
    this.props.onDeleteAllProductsFromCart();
    if (this.state.categoriesType[1].active) {
      this.props.onAddProductToCart({
        product: this.state.productStandBy,
        business: this.state.businessStandBy,
      });
      this.props.onRestaurantSelected(this.state.businessStandBy);
    } else {
      this.props.onFetchingMealOptionsFromPopularDish({
        product: this.state.productStandBy,
        business: this.state.businessStandBy,
      });
      this.props.onRestaurantSelected(this.state.businessStandBy);
    }
    this.setState({ differentRestaurant: false });
  };

  handleDenyCartModal = () => {
    this.setState({ differentRestaurant: false });
  };

  handleCloseHandlingError = () => {
    this.props.onErrorHandling({ showError: false, errorMessage: '' });
  };

  handleCloseModalPlacedOrderOnCart = () => {
    this.props.closeModalPlacedOrderOnCart(this.props.history);
  };

  getAddress = () => {
    return this.props.addresses[0];
  };

  isDeliverAtHome = () => {
    return this.getAddress() != null
      ? this.getAddress().idCustomerDeliveryAddress != null
      : false;
  };

  render() {
    return (
      <Aux>
        <ErrorHandling
          handlingError={this.props.errorHandling}
          closedErrorModal={this.handleCloseHandlingError}
        >
          <ProductsDetails />
          <ModalCartMessage
            clickButtonConfirm={this.handleConfirmOkCartModal}
            clickButtonDeny={this.handleDenyCartModal}
            message={
              <strong>
                Note! You can only order from <br /> one restaurant at a time.
                <br />
                <br />
                Clear current basket to add?
              </strong>
            }
            showModal={this.state.differentRestaurant}
          />
          <ModalErrorPlacedOrder
            showModal={this.props.modalErrorPlacedOrder}
            closeModal={this.props.closeModalErrorPlacedOrder}
            errorMessage={this.props.checkoutError || this.props.errorMessage}
          />
          <ModalSuccessPayment
            descriptionSuccess={
              this.props.cart.isInvoice
                ? this.props.invoice.descriptionSuccess
                : this.props.cart.descriptionSuccess
            }
            isInvoice={this.props.cart.isInvoice}
            closeModal={this.handleCloseModalPlacedOrderOnCart}
            showModal={this.props.showSuccessPaymentModal}
            openReceipt={this.props.openModalReceiptOnCart}
          />
          <ModalReceipt
            showModal={this.props.showReceiptModal}
            closeModal={this.props.closeModalReceiptOnCart}
            data={this.getReceiptData()}
          />
          <div className="main-content" aria-label="Order categories">
            <Categories
              categoriesType={this.state.categoriesType}
              selectCategory={this.handleSelectCategory}
              showCategoriesMobile={this.state.showCategoriesMobile}
              toggleCategoriesNavClass={this.toggleCategoriesNavClass}
              showRestaurantsMobile={this.props.showRestaurantsMobile}
              toggleRestaurants={this.toggleRestaurants}
              checkout={this.props.checkout}
              toggleCart={this.toggleCart}
            />
            {this.state.categoriesType[0].active ? (
              <PopularDish
                checkout={this.props.checkout}
                restaurantsOptions={this.props.restaurantsOptions}
                selectProduct={this.handleSelectProductFromPopularDish}
                popularDishItems={this.props.popularDishDelivery}
              />
            ) : (
              <RecentlyOrdered
                checkout={this.props.checkout}
                restaurantsOptions={this.props.restaurantsOptions}
                addRepeatOrderProduct={this.handleAddRecentlyOrderProduct}
                showLoading={this.props.loadingRecentlyOrder}
                recentlyOrdered={this.props.recentlyOrdered}
              />
            )}
            <Cart />
          </div>
        </ErrorHandling>
      </Aux>
    );
  }
}

const mapStateToProps = state => {
  return {
    restaurantsOptions: state.menuReducer.restaurantsOptions,
    restaurantSelected: state.menuReducer.restaurantSelected,
    userDetails: state.authenticationReducer.userDetails,
    listAddress: state.menuReducer.listAddress,
    popularDishDelivery: state.menuReducer.popularDishDelivery,
    recentlyOrdered: state.menuReducer.recentlyOrdered,
    loadingRecentlyOrder: state.menuReducer.loadingRecentlyOrder,
    showRestaurantsMobile: state.menuReducer.showRestaurantsMobile,
    cart: state.cartReducer.cart,
    invoice: state.invoiceReducer.invoice,
    checkout: state.cartReducer.cart.checkout,
    showSuccessPaymentModal: state.cartReducer.cart.showPlacedModal,
    showReceiptModal: state.cartReducer.cart.showReceiptModal,
    restaurantOnCart: state.cartReducer.cart.restaurantSelected,
    modalErrorPlacedOrder: state.cartReducer.cart.modalErrorPlacedOrder,
    errorMessage: state.cartReducer.cart.errorLimit,
    checkoutError: state.cartReducer.cart.checkoutError,
    errorHandling: state.menuReducer.errorHandling,
    showCollectionOption: state.menuReducer.showCollectionOption,
    addresses: state.menuReducer.addresses,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onFetchingMenu: (idBusiness, idAddress) =>
      dispatch(menuActions.fetchingMenu(idBusiness, idAddress)),
    onChangeTitleHeader: titleHeader =>
      dispatch(menuActions.changeMenuTitleHeader(titleHeader)),
    onFetchingListAddressForOrder: email =>
      dispatch(menuActions.fetchingListAddressForOrder(email)),
    onRestaurantSelected: restaurant =>
      dispatch(menuActions.restaurantSelected(restaurant)),
    onSelectProduct: product => dispatch(menuActions.selectProduct(product)),
    onAddProductToCart: products =>
      dispatch(menuActions.addProductToCart(products)),
    onFetchingMealOptionsFromPopularDish: payload =>
      dispatch(menuActions.fetchingMealOptionsFromPopularDish(payload)),
    onDeleteAllProductsFromCart: () =>
      dispatch(menuActions.deleteAllProductsFromCart()),
    onToggleCart: status => dispatch(menuActions.toggleCart(status)),
    onToggleRestaurants: status =>
      dispatch(menuActions.toggleRestaurants(status)),
    cartToggleShowModalReceipt: isClosing =>
      dispatch(menuActions.cartToggleShowModalReceipt(isClosing)),
    closeModalErrorPlacedOrder: () =>
      dispatch(menuActions.closeModalErrorPlacedOrder()),
    closeModalPlacedOrderOnCart: history =>
      dispatch(menuActions.closeModalPlacedOrderOnCart(history)),
    closeModalReceiptOnCart: () =>
      dispatch(menuActions.closeModalReceiptOnCart()),
    openModalReceiptOnCart: () =>
      dispatch(menuActions.openModalReceiptOnCart()),
    onErrorHandling: errorMessage =>
      dispatch(menuActions.errorHandling(errorMessage)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DefaultMenu);



// WEBPACK FOOTER //
// ./src/containers/Menu/DefaultMenu/DefaultMenu.js